import { Injectable } from '@angular/core';
import { ComponentService } from './component.service';
import { NewApiHttpService } from './new-api-http.service';
import { Observable, throwError } from 'rxjs';
import { OverlayService } from './overlay.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class FilesManagerService {
	constructor(private comService: ComponentService, private newApiHttpService: NewApiHttpService, private overlay: OverlayService) {}

	uploadFile(file: File): Observable<any> {
		var alreadyDisabledSave;
		const disabledSaveSubscription = this.comService.disabledSave.subscribe((res) => {
			alreadyDisabledSave = res;
		});
		var alreadyDisabledSaveBefore = alreadyDisabledSave;
		this.comService.updateDisabledSave(true);

		return this.newApiHttpService.newApiRequestUpload('cms', { file }).pipe(
			tap(() => {
				if (!alreadyDisabledSaveBefore) {
					this.comService.updateDisabledSave(false);
				}
				disabledSaveSubscription.unsubscribe();
			}),
			catchError((error): Observable<any> => {
				this.overlay.updateOverlay(true, error, 'alert');
				if (!alreadyDisabledSaveBefore) {
					this.comService.updateDisabledSave(false);
				}
				disabledSaveSubscription.unsubscribe();
				return throwError(error);
			})
		);
	}

	getFileList(start, type, order) {
		const data = { start: start, type: type, order: order };
		return this.newApiHttpService.newApiRequestGet('cms', data);
	}

	importFile(importUrl) {
		return this.newApiHttpService.newApiRequestPost('cms/import', { file: importUrl });
	}

	deleteFile(fileName) {
		return this.newApiHttpService.newApiRequestDelete('cms', { file: fileName });
	}
}
